import { render, staticRenderFns } from "./SvgDescription.vue?vue&type=template&id=20aa6210&scoped=true&"
import script from "./SvgDescription.vue?vue&type=script&lang=js&"
export * from "./SvgDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aa6210",
  null
  
)

export default component.exports